import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PublicCalculator from "../components/Publiccalculator";
import logo from "../assets/walletven.png";
import Navbar from "../components/Navbar";
import CreateWalletModal from "../components/createWalletModal";
import ContactForm from "../components/ContactForm";

const STEPS = [
  {
    title: "Registro y Verificación",
    text: "Regístrate. Abre tu Cuenta Walletven y acredita tu identidad para poder operar de manera remota. ¿No tienes Wallet? Abre una ya mismo.",
  },
  {
    title: "Selecciona el Activo",
    text: "Canjea tu dinero por la Criptomoneda que desees enviar a tu Wallet.",
  },
  {
    title: "Recibe el Activo",
    text: "Una vez recibidas las Criptomonedas en tu Wallet, podrás reenviarlas a cualquier Wallet de tus familiares o amigos.",
  },
];


const FAQS = (setShowWallet, setShowNetworks) => [
  {
    q: "¿Qué es Walletven?",
    a: "Walletven te permite canjear tu dinero por USDC y otras Criptomonedas populares de manera 100% legal y enviarlas directamente a las Wallets de tus familiares o amigos, en un proceso rápido, simple y seguro."
  },
  {
    q: "¿Cómo Funciona Walletven?",
    a: "Walletven te permite canjear tu dinero por Criptomonedas. Una vez realizado el pago, las Criptomonedas se reciben en la Wallet que hayas indicado, en un plazo casi inmediato. Luego, podrás transferir estos activos a cualquier Wallet que desees, en cualquier parte del mundo."
  },
 {
    q: "¿En qué plazo se reciben las Criptomonedas después del pago?",
    a: "El canje de Criptomonedas generalmente tarda desde unos minutos hasta algunas horas, dependiendo de factores como la congestión de la Red y la liquidez de los Tokens."
  },
  {
    q: "¿Por qué debo acreditar mi identidad?",
    a: "Como empresa regulada, estamos obligados a verificar la identidad de todos los usuarios en operaciones no presenciales, empleando procedimientos seguros de identificación. Te lo solicitaremos solo por una vez, al realizar tu primera transacción."
  },
  {
    q: "¿No tienes wallet?",
    a: (
      <>
        No te preocupes. Desde Walletven puedes crear tu primera Wallet de Criptomonedas{" "}
        <button
          type="button"
          onClick={() => setShowWallet(true)}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            color: "#fc364e",
            textDecoration: "underline",
            cursor: "pointer",
            font: "inherit",
          }}
        >
          AQUÍ
        </button>{" "}
        usando solo tu correo, sin frases semilla, sin extensiones.
        <br />
        {/* ADVERTENCIA: Las Wallets creadas con Walletven no son compatibles con todas las Criptomonedas y/o Redes. Si no estás seguro, contacta primero con Atención al Cliente. */}
          {/* Advertencia — abre popup con redes compatibles */}
              <button
                type="button"
                className="wallet-warning-banner"
                onClick={() => setShowNetworks(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  width: "100%",
                  textAlign: "left",
                  background: "rgba(245, 158, 11, 0.10)",
                  border: "1px solid rgba(245, 158, 11, 0.40)",
                  color: "var(--warning, #b45309)",
                  borderRadius: 10,
                  padding: "10px 12px",
                  margin: "5px 0 14px",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                <span style={{ fontSize: 16, lineHeight: 1 }}>⚠️</span>
                <span>Advertencia: revisa las redes compatibles con tu wallet</span>
                <span style={{ marginLeft: "auto", opacity: 0.7, whiteSpace: "nowrap" }}>Ver ›</span>
              </button>
      </>
    ),
  },
  {
    q: "¿Cómo contacto con Atención al Cliente?",
    a: (
      <>
        Ponemos a tu disposición un Chat Online{" "}
        <button
          type="button"
          onClick={() => setShowWallet(true)}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            color: "#fc364e",
            textDecoration: "underline",
            cursor: "pointer",
            font: "inherit",
          }}
        >
          AQUÍ
        </button>
        , una sección para enviar Emails desde nuestra web y un Servicio Telefónico de Atención al Cliente al +34 91
        993 13 12.
      </>
    ),
  },
];


function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen((o) => !o)}>
        <span>{q}</span>
        <span className={`faq-chevron ${open ? "is-open" : ""}`}>⌄</span>
      </button>
      {open && <p className="faq-answer">{a}</p>}
    </div>
  );
}

// Redes soportadas por la wallet creada en Walletven
const SUPPORTED_NETWORKS = [
  "Arbitrum", "Base", "Berachain", "Binance Smart Chain", "Celo", "Chiliz",
  "Cronos", "Etherlink", "Fantom", "Flare", "Harmony", "Hedera", "Horizen EON",
  "Loopring", "Moonbeam", "Optimism", "Plume", "Polygon", "Rari Chain", "Sei",
  "Soneium", "Stability", "XDC Network", "ZetaChain", "zkSync",
];

export default function HomePage() {
  const [showWallet, setShowWallet] = useState(false);
  const [showNetworks, setShowNetworks] = useState(false); // Advertencia popup


  const navigate = useNavigate();

  return (
    <div className="">
      <Navbar />

      <section className="hero canvas">
        <div className="hero-copy">
          <h1 className="hero-title">
          Consigue<br/>
tus Criptos.<br/>
Rápido,<br/>
Simple y<br/>
Seguro.
          </h1>
          <p className="hero-text">
            Canjea tu dinero por Criptomonedas y realiza tus envíos a familiares y amigos través de USDC y otras Criptomonedas estables.
          </p>
          <div className="d-flex gap-3">
            <button className="btn btn-primary " onClick={() => setShowWallet(true)}>
              ¿No tienes wallet?
            </button>
            <button className="btn btn-outline " onClick={() => navigate("/register")}>
              Regístrate
            </button>
          </div>
        </div>

        <PublicCalculator />
      </section>

      <CreateWalletModal open={showWallet} onClose={() => setShowWallet(false)} />

      <section className="how-it-works canvas" id="como-funciona">
        <p className="eyebrow center fw-bold">¿Cómo Funciona?</p>
        <div className="steps-grid">
          {STEPS.map((step, i) => (
            <div className="step-card" key={step.title}>
              <span className="step-index">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-text">{step.text}</p>

              {i === 0 && (
                <button
                  className="btn btn-primary"
                  style={{ marginTop: 18, display: "block" }}
                  onClick={() => setShowWallet(true)}
                >
                  Crear Wallet
                </button>
              )}

            </div>
          ))}
        </div>
      </section>


      <section className="faq-section canvas" id="faq">
        <p className="eyebrow center fw-bold">Preguntas Frecuentes</p>
        <div className="faq-list">
          {FAQS(setShowWallet, setShowNetworks).map((item) => (
            <FaqItem key={item.q} {...item} />
          ))}
        </div>
      </section>

      <section className="contact-section canvas" id="contacto">
        <div className="contact-inner">
          <div className="contact-copy">
            <p className="eyebrow center fw-bold">Contacto</p>
            <br></br>
          </div>
          <ContactForm />
        </div>
      </section>

    {/* ── Advertencia popup: redes compatibles ─────────────────────────── */}
      {showNetworks && (
        <div
          onClick={() => setShowNetworks(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1100, padding: 16,
          }}
        >
          <div
            className="modal-card"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: 480, width: "100%" }}
          >
            <div className="wallet-modal-header">
              <h3 className="modal-title">⚠️ Advertencia</h3>
              <button className="wallet-modal-close" onClick={() => setShowNetworks(false)}>✕</button>
            </div>
            <p className="modal-body">
              La wallet creada en Walletven <strong>solo soporta</strong> las siguientes redes:
            </p>
            <div className="wallet-networks-list" style={{display: "flex", flexWrap: "wrap", gap: "10px"}}>
              {SUPPORTED_NETWORKS.map((n) => (
                <span key={n} className="wallet-network-tag">{n}</span>
              ))}
            </div>
            <p className="fine-print" style={{ marginTop: 16 }}>
              Si tienes dudas, consulta primero con <strong>Atención al Cliente</strong>.
            </p>
            <button
              className="btn btn-primary btn-block"
              onClick={() => setShowNetworks(false)}
              style={{ marginTop: 16 }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}

      <footer className="site-footer">
        <div className="footer-inner canvas">
          <div className="footer-brand">
            <img src={logo} alt="Walletven" className="footer-logo" />
            <div className="footer-socials">
              <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" className="footer-social-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
              </a>
              <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="footer-social-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noreferrer" className="footer-social-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" /></svg>
              </a>
            </div>
            <div className="footer-contact">
              <span>🕐 L a V de 10 a 18 Hrs.</span>
              <span>📞 +34 91 993 13 12</span>
              <span>💬 +34 620 81 81 81</span>
              <span>✉️ hola@walletven.com</span>
            </div>
          </div>

          <div className="footer-col">
            <p className="footer-col-title">Ayuda</p>
            <a href="https://wa.me/34644571166" target="_blank" rel="noreferrer">Chat online</a>
            <a href="/#contacto">Contacto</a>
            <a href="/terms">Términos y Condiciones</a>
            <a href="https://www.youtube.com/@Transferveneuropa" target="_blank" rel="noreferrer">Instrucciones</a>
          </div>

          <div className="footer-col">
            <p className="footer-col-title">Información</p>
            <a href="/privacy">Política de Privacidad</a>
            <a href="/avisolegal">Aviso Legal</a>
            <a href="/cookies">Política de Cookies</a>
            <a href="/protection">Protección de Datos</a>
          </div>

          <div className="footer-badges">
            <img src="https://transferven.com/static/media/geslopd.d65c7913f490642bb2cf.png" width={150} />
            <img src="https://transferven.com/static/media/EXPERIENCE.be22da87ea1fb05d3d42.png" width={150} />
          </div>
        </div>

        <div className="footer-bottom canvas">
          <p>Copyright © 2017 - {new Date().getFullYear()} Walletven.com. Todos los derechos reservados. Walletven.com es una marca registrada. Cumplimos con la regulación vigente en materia de Prevención de Blanqueo de Capitales y Prevención en Financiación del Terrorismo.</p>
        </div>
      </footer>

    </div>
  );
}